var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 18c0-.3 0-.6.1-.9l-4.8-2.8c-1.2 1.2-3.2 1.2-4.4 0s-1.1-3.3.1-4.5C6 8.6 8 8.6 9.2 9.8L14 7c-.5-1.6.4-3.4 2-3.9s3.4.4 3.9 2-.4 3.4-2 3.9c-1.1.4-2.3.1-3.1-.7L10 11.1c.2.6.2 1.3 0 1.9l4.8 2.8c1.2-1.2 3.2-1.2 4.4 0 1.2 1.2 1.2 3.2 0 4.4-1.2 1.2-3.2 1.2-4.4 0-.6-.6-1-1.4-1-2.2zm1.5 0c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6-.8 0-1.6.7-1.6 1.6zm-9.9-6c0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6-.9 0-1.6.7-1.6 1.6zm9.9-6c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6-.8 0-1.6.7-1.6 1.6z",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic_share.d49afba18dcbb1c5c9ebc6df472238d6.svg";
export { ForwardRef as ReactComponent };